import Hls from 'hls.js'

export const isInvalidSrc = src => {
  return !src || src.includes(location.origin + location.pathname)
}

export const loadVideoNode = (node, src) => {
  // eslint-disable-next-line no-useless-escape
  const isMP4 = /^https:\/\/[\w\-]+(\.[\w\-]+)+([\w\-.,@?^=%&:\/~+#]*[\w\-@?^=%&\/~+#])?\.mp4$/.test(src)
  // eslint-disable-next-line no-useless-escape
  const isWebm = /^https:\/\/[\w\-]+(\.[\w\-]+)+([\w\-.,@?^=%&:\/~+#]*[\w\-@?^=%&\/~+#])?\.webm$/.test(src)
      
  if(!isMP4 && !isWebm) {
    const hls = new Hls()
    hls.loadSource(src)
    hls.attachMedia(node)
  }
}